import './ErrorBoundary.less';
import { ErrorBoundary } from 'react-error-boundary';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';

const ErrorBoundaryFallback = ({ resetErrorBoundary }) => {
    return (
        <div className="error-boundary">
            <span>Oops, something went wrong. Please </span>
            <Button className="ant-btn ant-btn-primary" onClick={resetErrorBoundary}>
                reload page
            </Button>
            <span> or go to the main page </span>

            <Link className="link" to="/">
                Existek{' '}
            </Link>
        </div>
    );
};

const ErrorBoundaryWrapper = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <ErrorBoundary
            key={location.pathname}
            FallbackComponent={ErrorBoundaryFallback}
            onReset={() => {
                navigate('/');
            }}
            onError={(error, info) => {
                console.error('Caught by ErrorBoundary:', error, info);
            }}
        >
            {children}
        </ErrorBoundary>
    );
};

export default ErrorBoundaryWrapper;
